export const cardData = [
    {
        id: 1,
        title: "Commercial Roll-Up",
        linkImg: "images/commercialRollUpDoors/rollingSteelServiceDoor.jpeg",
            desc1:'Rolling Steel Doors', 
            desc2:'Sectional Doors',
            desc3:'Sheet and storage',
            desc4:'Unit Doors', 
            desc5:'Rolling Doors',
            desc6:'Aluminum Grilles', 
            desc7:'Sliding Aluminum Grilles'
    },
    {
        id: 2,
        title: "Glass Aluminum Entries",
        linkImg: "images/storefrontAndGlassAluminumDoors/aluminumGlassDoors.webp",
            desc1:'Panic Glass Aluminum doors', 
            desc2: 'All Glass Herculite Doors', 
            desc3: 'Glass Sliding Doors', 
            desc4: 'Storefronts'
    },
    {
        id: 3,
        title: "Metal and Wood Doors",
        linkImg: "images/storefrontAndGlassAluminumDoors/aluminumGlassDoors.webp",
        desc1: 'Hollow Metal Doors', 
        desc2: 'Solid Core Wood Doors', 
        desc3: 'Laminated Wood Doors', 
        desc4: 'Primed Coat Wood Doors'
    },
    {
        id: 4,
        title: "Specialty Doors",
        linkImg: "images/hollowMetalDoors/HollowMetalDoors.webp",
        desc1:'Stainless Steel Doors',
        desc2: 'Fiber Glass Doors', 
        desc3: 'Impact Doors', 
        desc4: 'Fire Rated Metal and Wood Doors'
    },
    {
        id: 5,
        title: "Automatic Doors",
        linkImg: "images/storefrontAndGlassAluminumDoors/aluminumGlassDoors.webp",
        desc1:'Automatic Sliding Doors',
        desc2: 'Automatic Swing Doors', 
        desc3: 'Automatic Folding Doors', 
        desc4: 'Automatic Telescopic Doors'
    },
    {
        id: 6,
        title: "Gates",
        linkImg: "images/storefrontAndGlassAluminumDoors/aluminumGlassDoors.webp",
        desc1: 'Wrought Iron and Chain Link Gates',
        desc2: 'Sliding and Swing gates', 
        desc3: 'Pedestrian'
    },
];
